import makeApiRequest from "./makeApiCall";

export const getAccountOfficers = async () => {
  return await makeApiRequest(`/customer/ao/all`, "GET", null);
};

export const saveAccountOfficer = async (data) => {
  return await makeApiRequest(`/customer/ao/save`, "POST", null, data);
};
